import React from "react";

function columnClass(column) {
  return column.className || "col-grow";
}

// Fora de uma <table> de propósito: o esqueleto não precisa casar larguras de
// célula com a tabela real, e o cartão que o envolve é o mesmo. `columns`
// descreve as barras — `bars: 2` na coluna que tem título e meta, `bars: 0`
// na coluna do chevron.
function TableSkeleton({ columns, rows = 10, label = "Carregando" }) {
  return (
    <div role="status" aria-label={label} aria-busy="true">
      <div className="thead-mock">
        {columns.map((column) => (
          <div className={`meta-label ${columnClass(column)}`} key={column.key}>
            {column.label}
          </div>
        ))}
      </div>

      {Array.from({ length: rows }, (_, row) => (
        <div className="skel-row" key={row}>
          {columns.map((column) => (
            <div className={columnClass(column)} key={column.key}>
              {(column.bars ?? 1) > 0 && <div className="skel" />}
              {(column.bars ?? 1) > 1 && <div className="skel skel-sm" />}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default TableSkeleton;
